export async function getResponseError({ response, reason, statusText, }) {
    return [
        `HTTP ${response.status}`,
        reason,
        statusText !== null && statusText !== void 0 ? statusText : (await getError(response)),
    ]
        .filter(f => !!f)
        .join(' - ');
}
export async function getError(response) {
    try {
        return response.text();
    }
    catch (e) {
        return response.statusText;
    }
}
